<ng-container *ngIf="data">
    <ng-container [ngSwitch]="data.dataType">
        <ng-container *ngSwitchCase="SideNaveDataTypes.MESSAGE_ACTIONS">
            <app-menu-side-actions-msg
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-actions-msg>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ALERT">
            <app-menu-side-alert-msg
                (onClose)="bottomSheetRef.dismiss($event)"
                [alertData]="data"
            ></app-menu-side-alert-msg>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_ROLE">
            <app-menu-side-add-role
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-role>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.PROMPT_REGENERATION">
            <app-menu-side-material-prompt-regeneration
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-material-prompt-regeneration>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.FINISH_WORK_WITH_GROUP">
            <app-menu-side-take-resource-group-work
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-take-resource-group-work>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.AI_CREATE_UPDATE_MEDIA">
            <app-menu-side-media-ai-create-update
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-media-ai-create-update>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_EDUCATOR">
            <app-menu-side-add-educator
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-educator>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.SELECT_PUBLISHER_LOGO">
            <app-menu-side-select-publisher-logo
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-select-publisher-logo>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_GROUP_INTO_TEAM">
            <app-menu-side-add-group-into-team
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-group-into-team>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.AI_GENERATE">
            <app-menu-side-generate-ai
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-generate-ai>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.DASHBOARD_COLUMN_SETTINGS">
            <app-menu-side-dashboard-column-settings
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-dashboard-column-settings> </ng-container
        ><ng-container *ngSwitchCase="SideNaveDataTypes.MANAGE_WIDGETS">
            <app-menu-side-manage-widgets
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-manage-widgets>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_NEXT_CONTACT">
            <app-menu-side-add-next-contact
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-next-contact>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_HR_NOTE">
            <app-menu-side-add-hr-note
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-hr-note>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_CUSTOMER">
            <app-menu-side-add-customer
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-customer>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.COURSE_ITEM_DONE_ALL">
            <app-menu-side-course-item-done-all
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-course-item-done-all>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.COURSE_MATERIAL_ITEM_DONE">
            <app-menu-side-course-material-item-done
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-course-material-item-done>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.COURSE_ITEM_DONE">
            <app-menu-side-course-item-done
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-course-item-done>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_USER">
            <app-menu-side-add-user
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-user>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.SELECT_PERMISSION_LEVEL">
            <app-menu-side-select-permission-level
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-select-permission-level>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_TASK">
            <app-menu-side-add-task
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-task>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.DOWNLOAD">
            <app-menu-side-download
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-download>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.SIGNOFF_FEEDBACK">
            <app-menu-side-signoff-feedback
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-signoff-feedback>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.RESOURCE_ENROLLMENT_APPROVAL">
            <app-menu-side-resource-enrollment-approve
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-resource-enrollment-approve>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.EVENT_JOIN">
            <app-menu-side-event-join
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-event-join>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.RESOURCE_ENROLLMENT_REQUEST">
            <app-menu-side-resource-enrollment-request
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-resource-enrollment-request>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.USER_ACTIONS_TEMPLATE">
            <app-menu-side-user-actions-template
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-user-actions-template>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.CANCEL_COURSE_PLAY">
            <app-menu-side-cancel-course-play
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-cancel-course-play>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.SEND_TEXT_BLOCK_MAIL">
            <app-menu-side-mail-text-block
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-mail-text-block>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.USER_NOTE">
            <app-menu-side-add-note
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-note>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.GENERAL_NOTIFIER">
            <app-menu-side-notifier
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-notifier>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.AI_PROMPTER">
            <app-menu-side-ai-prompter
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-ai-prompter>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.CREATE_TEST_FROM_MATERIAL">
            <app-menu-side-video-to-quiz
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-video-to-quiz>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_RESOURCE_MEDIA">
            <app-menu-side-add-media-with-options
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-media-with-options>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_LINK_MATERIAL">
            <app-menu-side-create-link-material
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-create-link-material>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.COURSE_REGISTER">
            <app-menu-side-course-register
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-course-register>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.SEND_MESSAGE">
            <app-menu-side-send-message
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-send-message>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.CHECK_EFFICIENCY">
            <app-menu-side-res-efficiency
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-res-efficiency>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.USER_PROGRESS">
            <app-menu-side-log-user-resource-events
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-log-user-resource-events>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.GENERAL_TEXT_AREA">
            <app-menu-side-text-area-field
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-text-area-field>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.QUESTION_EXTRA_INFO">
            <app-menu-side-question-extra-info
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-question-extra-info>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_RESOURCE_QUESTIONS">
            <app-menu-side-add-resource-questions
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-resource-questions>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.ADD_COURSE_ITEMS">
            <app-menu-side-add-course-items
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-add-course-items>
        </ng-container>

        <ng-container *ngSwitchCase="SideNaveDataTypes.COURSE_REGISTER">
            <app-menu-side-course-register
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-course-register>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.MEDIA_ATTACHMENT">
            <app-menu-side-display-media
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-display-media>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.SEND_MAIL">
            <app-menu-side-send-mail
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-send-mail>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.INFORM_TAKE_RESOURCE">
            <app-menu-side-inform-take-resource
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-inform-take-resource>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.TAKE_EVENT">
            <app-menu-side-take-event
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-take-event>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.EVENT_REGISTER">
            <app-menu-side-event-reg
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-event-reg>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.ALL_QUOTES">
            <app-menu-side-show-all-quotes
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-show-all-quotes>
        </ng-container>
        <ng-container *ngSwitchCase="SideNaveDataTypes.RESOURCE_MANAGERS">
            <app-menu-side-resource-managers
                (onClose)="bottomSheetRef.dismiss($event)"
                [navData]="data"
            ></app-menu-side-resource-managers>
        </ng-container>
    </ng-container>
</ng-container>
